import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import './style.css';

const menus = [
  {
    id: 1,
    title: 'Home',
    link: '/home',
    icon: 'ti-home',
  },
  {
    id: 2,
    title: 'RSVP',
    link: '/rsvp',
    icon: 'ti-pencil-alt',
  },
  {
    id: 3,
    title: 'Lista Nozze',
    link: '/shop',
    icon: 'ti-gift',
  },
  {
    id: 4,
    title: 'Album',
    link: '/gallery',
    icon: 'ti-image',
  },
  {
    id: 5,
    title: 'Contributi',
    link: '/cart',
    icon: 'ti-heart',
  },
  {
    id: 6,
    title: 'Checkout',
    link: '/checkout',
    icon: 'ti-shopping-cart',
  },
  {
    id: 7,
    title: 'Contatti',
    link: '/contact',
    icon: 'ti-email',
  },
];

const MobileMenu = () => {
  const [openId, setOpenId] = useState(0);
  const [menuActive, setMenuState] = useState(false);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div>
      <div className={`mobileMenu ${menuActive ? 'show' : ''}`}>
        <div className="menu-close">
          <div className="clox" onClick={() => setMenuState(!menuActive)}>
            <i className="ti-close"></i>
          </div>
        </div>

        <ul className="responsivemenu">
          {menus.map((item, mn) => {
            return (
              <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                {item.submenu ? (
                  <Fragment>
                    <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>
                      {item.title}
                      <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                    </p>
                    <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                      <List className="subMenu">
                        <Fragment>
                          {item.submenu.map((submenu, i) => {
                            return (
                              <ListItem key={i}>
                                <Link onClick={ClickHandler} to={submenu.link}>
                                  {submenu.title}
                                </Link>
                              </ListItem>
                            );
                          })}
                        </Fragment>
                      </List>
                    </Collapse>
                  </Fragment>
                ) : (
                  <Link onClick={ClickHandler} to={item.link}>
                    <i className={item.icon}></i>
                    {item.title}
                  </Link>
                )}
              </ListItem>
            );
          })}
        </ul>
      </div>

      <div className="showmenu" onClick={() => setMenuState(!menuActive)}>
        <button type="button" className="navbar-toggler open-btn">
          <span className="icon-bar first-angle"></span>
          <span className="icon-bar middle-angle"></span>
          <span className="icon-bar last-angle"></span>
        </button>
      </div>
    </div>
  );
};

export default MobileMenu;
